import { render } from "./IconChevronDoubleLeft.vue?vue&type=template&id=3ae26d8e"
import script from "./IconChevronDoubleLeft.vue?vue&type=script&lang=js"
export * from "./IconChevronDoubleLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__